import { RootState } from '@/store/main';
import { ChannelFeatures, ChannelFeaturesEnum, FeatureFlagMap, FeatureFlagsEnum } from './types';

export const selectFeatureFlags = (state: RootState): FeatureFlagMap => state.featureFlags.featureFlags;
export const selectChannelFlags = (state: RootState): ChannelFeatures => state.featureFlags.channelFeatures;
export const selectFeatureFlag =
  (flag: FeatureFlagsEnum) =>
  (state: RootState): boolean =>
    !!state.featureFlags.featureFlags[flag];
export const selectChannelFlag =
  (flag: ChannelFeaturesEnum) =>
  (state: RootState): boolean =>
    !!state.featureFlags.channelFeatures[flag];
